import { render } from "./App.vue?vue&type=template&id=b313d3c0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b313d3c0&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__